import { Getter } from "vuex";
import { IArticle, IFilter, IState } from './state';


const articles: Getter<IState, IState> = (state, getters) => {
    const queries = state.query.split(/[\s\-]/g)
    const query = new RegExp(`(${queries.join('|')})`, 'gi');
    const endIndex = (state.currentPage + 1) * state.hitsPerPage
    const filters = getters.selectedFilters;
    let articles = state.articles.filter(article => {
        return article.title.match(query)  
            || article.preamble.match(query) 
            || article.labels.some(label => label.match(query))
    })

    if (filters.length) {
        articles = articles.filter((article: IArticle) => {
            return filters.some((filter: IFilter) => {
                return article.labels.includes(filter.name)
            })
        })
    }
    
    return {
        total: articles.length,
        list: articles.slice(0, endIndex)
    }
}
const total: Getter<IState, IState> = (state, getters) => getters.articles.total
const currentHits: Getter<IState, IState> = (state, getters) => getters.articles.list.length
const selectedFilters: Getter<IState, IState> = (state, getters) => state.filters.filter(filter => filter.selected)
const pages: Getter<IState, IState> = (state, getters) => Math.ceil(getters.total / state.hitsPerPage)


export default {
    pages,
    articles,
    total,
    currentHits,
    selectedFilters
}
